var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapPointer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 60,
    viewBox: "0 0 8 10",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 0C2.065 0 0.5 1.565 0.5 3.5C0.5 6.125 4 10 4 10C4 10 7.5 6.125 7.5 3.5C7.5 1.565 5.935 0 4 0ZM1.5 3.5C1.5 2.12 2.62 1 4 1C5.38 1 6.5 2.12 6.5 3.5C6.5 4.94 5.06 7.095 4 8.44C2.96 7.105 1.5 4.925 1.5 3.5ZM2.75 3.5C2.75 2.80964 3.30964 2.25 4 2.25C4.44658 2.25 4.85924 2.48825 5.08253 2.875C5.30582 3.26175 5.30582 3.73825 5.08253 4.125C4.85924 4.51175 4.44658 4.75 4 4.75C3.30964 4.75 2.75 4.19036 2.75 3.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPointer);
export default __webpack_public_path__ + "static/media/map_pointer.9126d2f9d63bafc58e28ade586bcbe68.svg";
export { ForwardRef as ReactComponent };